module.exports = __webpack_public_path__ + "static/media/EQUIPTOP.f478f6a7.mp4";